import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=63275a85&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=63275a85&prod&scoped=true&lang=css"
import style1 from "./Department.vue?vue&type=style&index=1&id=63275a85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63275a85",
  null
  
)

export default component.exports